import { html } from 'lit';
import store from '@mfe/store';
import service from '@mfe/service';
import { TRACKER_EVENT_NAME_CANCEL_CHANGE_PERMISSION } from '@mfe/service/tracker';
import { saveAndLoad, cancelEditMode } from '@mfe/store/consents';
import { ConsentGroup } from '@mfe/types/common';

export const viewTemplate = (
  consentGroup: ConsentGroup,
  editmodeActiveGroupInd: number,
  changesMade: boolean,
) => html`

          <tef-coms-consent-group
            .consentGroup=${consentGroup}
            .groupIndex=${editmodeActiveGroupInd}
          ></tef-coms-consent-group>

            <one-button-group>
              <one-button
              .disabled=${!changesMade}
              @click=${
  () => {
    store.dispatch(saveAndLoad());
  }
}
          >
              Speichern
          </one-button>
              <one-spacer size="fill"></one-spacer>
               <one-button
                  variant="plain"
                  @click=${
  () => {
    store.dispatch(cancelEditMode());
    service.tracker.doTracking(
      TRACKER_EVENT_NAME_CANCEL_CHANGE_PERMISSION,
      {
        group:
                            consentGroup.name
                            || 'noname',
      },
    );
  }
}
               >
                  Abbrechen
               </one-button>

            </one-button-group>
    `;

export default viewTemplate;
